<template>
  <div class="view">
    <div class="view_title">
      <div class="view_title_item view_title_item_left">
        <span>女性</span>
        <div class="view_title_text_bg"/>
      </div>

      <div class="view_title_item title_right">
        <div class="view_title_item_riht_show">
          <img src="../../assets/images/nv.png">
        </div>
        <div class="view_title_item_riht_bg">
          <img src="../../assets/images/zitu_bg_icon.png">
        </div>
      </div>
    </div>
    <div class="view_content_bg">
      <div class="view_content_bg_title">详情数据</div>

      <div class="view_content_bg_item" @click="openValue('雌性激素')">
        <div class="view_content_bg_item_title">
          <span>雌性激素</span><span>{{ female1Index }}分</span><span>/100</span><span>{{ female1 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="female1" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>

      <div class="view_content_bg_item" @click="openValue('泌乳素')">
        <div class="view_content_bg_item_title">
          <span>泌乳素</span><span>{{ female2Index }}分</span><span>/100</span><span>{{ female2 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="female2" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item" @click="openValue('黄体酮')">
        <div class="view_content_bg_item_title">
          <span>黄体酮</span><span>{{ female3Index }}分</span><span>/100</span><span>{{ female3 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="female3" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item"  @click="openValue('阴道炎')">
        <div class="view_content_bg_item_title">
          <span>阴道炎</span><span>{{ female4Index }}分</span><span>/100</span><span>{{ female4 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="female4" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item" @click="openValue('盆腔炎')">
        <div class="view_content_bg_item_title">
          <span>盆腔炎</span><span>{{ female5Index }}分</span><span>/100</span><span>{{ female5 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="female5" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item"  @click="openValue('附件炎')">
        <div class="view_content_bg_item_title">
          <span>附件炎</span><span>{{ female6Index }}分</span><span>/100</span><span>{{ female6 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="female6" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item" @click="openValue('宫颈炎')">
        <div class="view_content_bg_item_title">
          <span>宫颈炎</span><span>{{ female7Index }}分</span><span>/100</span><span>{{ female7 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="female7" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item" @click="openValue('卵巢囊肿')">
        <div class="view_content_bg_item_title">
          <span>卵巢囊肿</span><span>{{ female8Index }}分</span><span>/100</span><span>{{ female8 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="female8" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item" @click="openValue('乳腺增生')">
        <div class="view_content_bg_item_title">
          <span>乳腺增生</span><span>{{ female9Index }}分</span><span>/100</span><span>{{ female9 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="female9" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>

      <div class="view_content_bg_item" @click="openValue('急性乳腺炎')">
        <div class="view_content_bg_item_title">
          <span>急性乳腺炎</span><span>{{ female10Index }}分</span><span>/100</span><span>{{ female10 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="female10" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>

      <div class="view_content_bg_item" @click="openValue('慢性乳腺炎')">
        <div class="view_content_bg_item_title">
          <span>慢性乳腺炎</span><span>{{ female11Index }}分</span><span>/100</span><span>{{ female11 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="female11" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>

      <div class="view_content_bg_item" @click="openValue('内分泌失调')">
        <div class="view_content_bg_item_title">
          <span>内分泌失调</span><span>{{ female12Index }}分</span><span>/100</span><span>{{ female12 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="female12" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div style="height: 28px"/>

    </div>
    <view_bottom></view_bottom>
  </div>
</template>

<script>
import view_bottom from "@/pages/healthy/view_bottom";
import axios from "axios";

export default {
  name: "ReportNv",
  components: {view_bottom},
  data() {
    return {
      female1: "",
      female2: "",
      female3: "",
      female4: "",
      female5: "",
      female6: "",
      female7: "",
      female8: "",
      female9: "",
      female10: "",
      female11: "",
      female12: "",
      female1Index: "",
      female2Index: "",
      female3Index: "",
      female4Index: "",
      female5Index: "",
      female6Index: "",
      female7Index: "",
      female8Index: "",
      female9Index: "",
      female10Index: "",
      female11Index: "",
      female12Index: "",

    }
  },
  created() {
    // document.title = '舌诊评估'
    let userId = this.$route.query.userId
    console.log(userId)
    this.getcode(userId)
  },
  methods: {
    getcode(userId) {
      let url = "https://smxxcx.slyxkj.com/jeecgboot/api/app/getandrology?" + userId
      // let url = "https://shezhen.yuanjiwei.cn/api/app/getfemale?" + userId
      this.br = "<br/>"
      axios.get(url)
          .then((result) => {
            console.log(result)
            this.female1 = result.data.result.female1
            this.female2 = result.data.result.female2
            this.female3 = result.data.result.female3
            this.female4 = result.data.result.female4
            this.female5 = result.data.result.female5
            this.female6 = result.data.result.female6
            this.female7 = result.data.result.female7
            this.female8 = result.data.result.female8
            this.female9 = result.data.result.female9
            this.female10 = result.data.result.female10
            this.female11 = result.data.result.female11
            this.female12 = result.data.result.female12
            this.female1Index = result.data.result.female1Index
            this.female2Index = result.data.result.female2Index
            this.female3Index = result.data.result.female3Index
            this.female4Index = result.data.result.female4Index
            this.female5Index = result.data.result.female5Index
            this.female6Index = result.data.result.female6Index
            this.female7Index = result.data.result.female7Index
            this.female8Index = result.data.result.female8Index
            this.female9Index = result.data.result.female9Index
            this.female10Index = result.data.result.female10Index
            this.female11Index = result.data.result.female11Index
            this.female12Index = result.data.result.female12Index
            this.initBarChart("female1", this.female1)
            this.initBarChart("female2", this.female2)
            this.initBarChart("female3", this.female3)
            this.initBarChart("female4", this.female4)
            this.initBarChart("female5", this.female5)
            this.initBarChart("female6", this.female6)
            this.initBarChart("female7", this.female7)
            this.initBarChart("female8", this.female8)
            this.initBarChart("female9", this.female9)
            this.initBarChart("female10", this.female10)
            this.initBarChart("female11", this.female11)
            this.initBarChart("female12", this.female12)

          }).catch(error => {
        this.$router.replace("error")
      });
    },
    initBarChart(view, count) {
      let jiankang = this.$echarts.init(document.getElementById(view))
      let option = {
        grid: {
          left: '0',
          top: '0',
          right: '0',
          bottom: '0',
          containLabel: true,
          width: '100%'
        },
        xAxis: {
          type: 'value',
          splitLine: {show: false},
          axisLabel: {show: false},
          axisTick: {show: false},
          axisLine: {show: false},

        },
        yAxis: {
          type: 'category',
          axisTick: {show: false},
          axisLine: {show: false},
          axisLabel: {
            color: 'black',
            fontSize: 25,
            show: false,
          },
        },
        series: [
          {
            type: 'bar',
            barWidth: 18,
            data: [count],
            label: {
              //position    : 'middle',
              offset: [20, 2],
              color: '#fff',
              fontSize: 30,
            },
            itemStyle: {
              color: this.$echarts.graphic.LinearGradient(
                  1, 0, 0, 0,
                  [
                    {offset: 0, color: '#16CCBD'},                   //柱图渐变色
                    // {offset: 0.5, color: '#44C0C1'},                 //柱图渐变色
                    {offset: 1, color: '#4BEB76'},                   //柱图渐变色
                  ]
              ),
              barBorderRadius: 9,
            },
            zlevel: 1
          },
          {
            name: '进度条背景',
            type: 'bar',
            barGap: '-100%',
            barWidth: 18,
            data: [100],
            color: '#E3ECF2',//柱条颜色
            itemStyle: {
              normal: {
                barBorderRadius: 9,
                borderColor: '#FEFEFE',
              }
            }
          }
        ]
      };
      jiankang.setOption(option);
    },
    openValue(info){
      this.$router.push({path:"/Healthy/Introduce",query:{userId:info,date:new Date().getTime()}})
    }
  }
}
</script>

<style scoped>

.view_content_bg_item {
  background: #F7FAFA;
  border-radius: 32px;
  margin-top: 24px;
  margin-left: 32px;
  margin-right: 32px;
}

.view_content_bg_item_title {
  padding: 32px 32px 16px;
}

.view_content_bg_item_title > span:nth-child(1) {
  font-size: 28px;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  text-align: left;
  vertical-align: top;
}

.view_content_bg_item_title > span:nth-child(2) {
  font-size: 28px;
  font-weight: 400;
  color: rgba(255, 195, 0, 1);
  padding-left: 16px;
  text-align: left;
  vertical-align: top;
}

.view_content_bg_item_title > span:nth-child(3) {
  font-size: 24px;
  font-weight: 400;
  color: rgba(199, 199, 199, 1);
  text-align: center;
  margin-top: 4px;
  padding-left: 6px;
  vertical-align: top;
  float: right;
}

.view_content_bg_item_title > span:nth-child(4) {
  font-size: 28px;
  font-weight: 400;
  color: rgba(23, 203, 188, 1);
  text-align: right;
  vertical-align: top;
  float: right;
}

.view_content_bg_item_buttom {
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 40px;
}
</style>
